import SearchIcon from '@mui/icons-material/Search'
import cx from 'classnames'
import { Kbd } from '../Kbd/Kbd'
import styles from './QuickSearchButton.module.css'

export interface QuickSearchButtonProps {
  /** Shown instead of "Search", e.g. the page heading */
  title?: string
  /** Called when the button is pressed, e.g. to open the search dialog */
  onClick: () => void
  /** Additional CSS class */
  className?: string
}

/**
 * Opens the global search. Shows the page title when given,
 * otherwise "Search" as a placeholder.
 *
 * The ⌘K / ctrl+K hint hides on devices without a fine pointer.
 */
export function QuickSearchButton({
  title,
  onClick,
  className,
}: QuickSearchButtonProps) {
  return (
    <button
      type="button"
      className={cx(styles.QuickSearchButton, className)}
      aria-haspopup="dialog"
      aria-label={title ? `Search — ${title}` : 'Search'}
      onClick={onClick}
      data-testid="quick-search-button"
    >
      <SearchIcon
        className={styles.QuickSearchButton__icon}
        aria-hidden="true"
      />
      <span
        className={cx(styles.QuickSearchButton__label, {
          [styles.isPlaceholder]: !title,
        })}
        data-testid="quick-search-button__label"
      >
        {title || 'Search'}
      </span>
      <span className={styles.QuickSearchButton__kbd}>
        <Kbd mod>k</Kbd>
      </span>
    </button>
  )
}
